<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_vii">IN THE HOUR BEFORE MIDNIGHT</a></h1><a id="page_vii">
<p class="author">Jack Higgins</p>
<div class="img_container">
<img alt="images" src="images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?823da140